import React from 'react';
import { Grid } from '@mui/material';
import { MobileApps, MobileAppVideos } from '../MobileApps.js';
import { Websites } from '../Websites.js';
import { Logos } from '../Logos.js';
import { PrintWork } from '../PrintWork.js';
import { AnimationsFlash } from '../AnimationsFlash.js';
import { AnimationsGif } from '../AnimationsGif.js';
import { ComputerArt } from '../3DArt.js';
import { Illustrations } from '../Illustrations.js';
import minilogo from '../assets/javasite/images/minilogo.png';

export function HomePage() {
const copyRightDate = new Date().getFullYear();

  return (
    <Grid container spacing={1}>
      <MobileAppVideos />
      <MobileApps />
      <Websites />
      <Logos />
      <PrintWork />
      <AnimationsFlash />
      <AnimationsGif />
      <ComputerArt />
      <Illustrations />
      <Grid container justifyContent="center" spacing={1}>
        <Grid item>
          <div id="about1" className="isoitem about-tope">
            <div className="blackbox">
              <div id="minilogo"><img src={minilogo} width="196" height="158" alt="DraZtic Mini Logo" /></div>
              <div id="title4"><strong>ABOUT DRAZTIC.COM</strong></div>
              <div id="abouttext" flex="" className="flex">
                <p>Welcome to DraZtic.com. This website was created by myself as a portfolio for my artwork on the web. Please feel free to look around the site. You will see many retail products and art work offering sales and services. These images, animations, web sites, apps, and graphics were created for clients and business associates for products and/or advertising services. <br />
                  <br />
                  These works, while designed by or collaborated on by myself, belong solely to their respective owners and are only being displayed on this site for demonstration/viewing purposes. Note that I have no control or input on the actual content and/or usage of these webpages and/or advertising materials, and the sites themselves aren't affiliated with DraZtic.com. </p>
                <p>&nbsp;</p>
                <p>All other artwork displayed on this site are copyrighted by myself (excluding fan based work). While you may see artwork based on other copyrighted characters (fanart) that I did not create, I myself do all the artwork. These particular works are strickly fan based and no money is made off of them.<br />
                  <br />
                  All images (unless stated otherwise) created by DraZtic, Copyright &copy; {copyRightDate}, All rights reserved
                  Please do not use images without permission. All non original/fan art characters copyright their respective owners.
                  <br />
                </p>
              </div>
            </div>
          </div>
        </Grid>
      </Grid>
    </Grid>
  );
}
